import { ERROR_MESSAGE_REQUIRED } from '../../config'
import FormSlide from '../FormSlide'
import { selectErrorHandling } from './common'

export default function YourSkillsEngineerSlide (props) {
  return (
    <FormSlide
      title='Can you tell us about your skills?'
      stageName='Finding your place at Aragon'
      description="We'd love to know a little about you. Do you have any skills or experience you think would be particularly valuable to the Aragon?"
      formData={[
        {
          text: 'Which category best describes your experience?',
          label: 'engineeringExpertise',
          placeholder: '',
          type: 'select',
          errorHandling: selectErrorHandling(''),
          options: [
            { value: 'front-end', text: 'Front-end' },
            { value: 'back-end', text: 'Back-end' },
            { value: 'full-stack', text: 'Full-Stack' },
            { value: 'smart contracts', text: 'Smart contracts' }
          ]
        },
        {
          text: 'Do you have experience with Web3 development?',
          label: 'web3Experience',
          placeholder: '',
          type: 'select',
          errorHandling: selectErrorHandling(''),
          options: [
            { value: 'none', text: 'None' },
            { value: 'up to 3 months', text: 'Up to 3 months' },
            { value: 'between 3 and 6 months', text: 'Between 3 and 6 months' },
            { value: 'more than 6 months', text: 'More than 6 months' }
          ]
        },
        {
          text: 'Can you share a link to your Github profile?',
          label: 'githubUrl',
          placeholder: '',
          type: 'text-box'
        },
        {
          text: `What other skills, beyond specific programming languages, would you bring to the Aragon?`,
          label: 'skills',
          placeholder: '',
          type: 'big-text-box',
          errorHandling: { required: ERROR_MESSAGE_REQUIRED }
        }
      ]}
      {...props}
    />
  )
}
